/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdf_Cv_Review_Category_ProfessionalismInputs */

const en_pdf_cv_review_category_professionalism = /** @type {(inputs: Pdf_Cv_Review_Category_ProfessionalismInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professionalism`)
};

const de_pdf_cv_review_category_professionalism = /** @type {(inputs: Pdf_Cv_Review_Category_ProfessionalismInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professionalität`)
};

/**
* | output |
* | --- |
* | "Professionalism" |
*
* @param {Pdf_Cv_Review_Category_ProfessionalismInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pdf_cv_review_category_professionalism = /** @type {((inputs?: Pdf_Cv_Review_Category_ProfessionalismInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdf_Cv_Review_Category_ProfessionalismInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pdf_cv_review_category_professionalism(inputs)
	return en_pdf_cv_review_category_professionalism(inputs)
});